import React from "react";
import ComingSoon from '../../components/ComingSoon/ComingSoon';

const Settings = () => {
  return <div><ComingSoon /></div>;
};

export default Settings;
